var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.21,9.58a5,5,0,1,1-5-5A5,5,0,0,1,15.21,9.58ZM12.37,11.8a.4.4,0,0,0-.14-.27.5.5,0,0,0-.28-.12.53.53,0,0,0-.3.09.43.43,0,0,0-.18.24.51.51,0,0,0,0,.3.43.43,0,0,0,.21.21.46.46,0,0,0,.57-.12.35.35,0,0,0,.08-.16A.33.33,0,0,0,12.37,11.8Zm-2.31-1.63h0a1.18,1.18,0,0,0,.72-.24,1.12,1.12,0,0,0,.4-.62,1.09,1.09,0,0,0-.08-.73,1.16,1.16,0,0,0-.53-.52A1.24,1.24,0,0,0,9.84,8a1.16,1.16,0,0,0-.64.39,1,1,0,0,0-.26.69,1.09,1.09,0,0,0,.24.69l1,1.3h-.09a2.07,2.07,0,0,1-1.31-.46,1.94,1.94,0,0,1-.71-1.16A2,2,0,0,1,8.3,8.09a2.09,2.09,0,0,1,1.06-.88,2.14,2.14,0,0,1,1.39,0A2,2,0,0,1,11.84,8a1.93,1.93,0,0,1,.28,1.32,2,2,0,0,1-.67,1.19l.35.46-.72.51-1-1.34Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo2);
export default __webpack_public_path__ + "static/media/info2.2352281811716631e4cbc26c6b7e124b.svg";
export { ForwardRef as ReactComponent };